import { useEffect, useState } from "react"
import useGetCosmos from "../../queries/use-get-cosmos"
import getCosmosKey from "../../utils/get-cosmos-key"
import loadConfig from "../../utils/load-config"
import { useCosmos } from "../../stores/use-cosmos-store"
import useEnv from "@/hooks/use-env"

export default function CosmosConfig({ children }: { children: React.ReactNode }) {
  const cosmosParam = getCosmosKey()
  const [isReady, setIsReady] = useState(false)
  const { data, isError, isSuccess, refetch } = useGetCosmos(cosmosParam)
  const { cosmosKey, setCosmos, cosmos } = useCosmos()
  const { isProd } = useEnv()

  useEffect(() => {
    const isLocalEnv = cosmosParam !== cosmosKey && !isProd

    if (cosmosKey === cosmosParam || isLocalEnv) {
      loadConfig(cosmos)
      setIsReady(true)
      return
    }

    refetch()
  }, [cosmosParam])

  useEffect(() => {
    if (isError) {
      setIsReady(true)
      return
    }

    if (isSuccess && data) {
      loadConfig(data.description.config)

      setCosmos({
        cosmosKey: cosmosParam,
        cosmos: data.description.config,
      })

      setIsReady(true)
    }
  }, [isSuccess, isError, data])

  useEffect(() => {
    loadConfig(cosmos)
  }, [cosmos])

  if (!isReady) {
    return (
      <div className="flex size-full items-center justify-center">
        <p>Cargando configuración...</p>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="flex size-full items-center justify-center">
        <p>Error al cargar la configuración.</p>
      </div>
    )
  }

  return <>{children}</>
}
